<!-- In this project we will be using Classy layout only -->
<!-- hideMenusAndButtons = true -> to hide navigation menu and all escape buttons -->
<classy-layout [hideMenusAndButtons]="hideMenusAndButtons" (onHideMenusAndButtonsChange)="hideMenusAndButtons = $event"> </classy-layout>
